import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-error-01',
	templateUrl: './icon-error-01.component.svg',
})
export class IconError01Component {}
